import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { capitalize, isEmpty, objChunk } from "@/commons/utils/functions";
import { required } from "@/commons/utils/Rules";
import { getDepartamentos, getLocalidad as _getLocalidad, getMunicipios } from "@/routes/api/resources";
import { mapGetters } from "vuex";
export default {
  name: "PzDirection",
  components: {},
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    askPostalCode: {
      type: Boolean,
      default: false
    },
    askCountry: {
      type: Boolean,
      default: false
    },
    viewline: {
      type: Boolean,
      default: true
    },
    isOnlyRead: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      direccion: {},
      levels: {
        municipio: [],
        localidad: [],
        departamento: []
      },
      addressC: [],
      loading: {
        municipio: false,
        localidad: false,
        departamento: false
      },
      rules: {},
      viewlinea: true
    };
  },
  computed: _objectSpread({}, mapGetters(['address'])),
  watch: {
    value: function value(val) {
      this.setParametersDirection(val);
    },
    direccion: function direccion(val) {
      this.handleChange(val);
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('loader/up', {
      trigger: this.$options.name
    });
    this.seta();
    this.setParametersDirection(this.value);
    this.fetchData().finally(function () {
      _this.$store.dispatch('loader/down', {
        trigger: _this.$options.name
      });
    });
  },
  methods: {
    required: required,
    isEmpty: isEmpty,
    isReadOnly: function isReadOnly() {
      if (this.isOnlyRead) {
        return true;
      }

      return false;
    },
    seta: function seta() {
      if (this.viewline) this.viewlinea = false;

      if (this.askPostalCode) {
        this.address['codigo_postal'] = {
          nombre: this.$t('commons.address.postal_code'),
          required: ""
        };
      }

      var conf = this.address;
      var direccion = [];

      if (!this.askCountry) {
        var self = this;
        direccion = Object.keys(conf).reduce(function (object, key) {
          if (self.address[key].base !== "Paises") {
            object[key] = self.address[key];
          }

          return object;
        }, {});
      } else {
        direccion = conf;
      }

      this.addressC = objChunk(direccion, 3);
    },
    handleChange: function handleChange(value) {
      this.setDirectionConfig();
      this.$emit('input', value);
    },
    setDirectionConfig: function setDirectionConfig() {
      var self = this;
      var promises = [];
      Object.entries(this.address).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        promises[key] = self.remote(value, key, false);
      });
      return Promise.all(promises);
    },
    setParametersDirection: function setParametersDirection(value) {
      var input = this.direccion;
      if (input === value) return;
      this.direccion = value;
    },
    fetchData: function fetchData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var deptos;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deptos = _this2.getDepartamento();
                return _context.abrupt("return", Promise.all([deptos]));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    remote: function remote(value, property) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var child, function_name;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (isEmpty(value.hijo)) {
                  _context2.next = 6;
                  break;
                }

                child = _this3.address[value.hijo];

                if (isEmpty(child.base)) {
                  _context2.next = 6;
                  break;
                }

                function_name = 'get' + capitalize(child.base);

                if (!_this3.direccion[property]) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", _this3[function_name](_this3.direccion[property], value.hijo));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getMunicipio: function getMunicipio(value) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading.municipio = true;
                getMunicipios(value).then(function (res) {
                  _this4.levels.municipio = res.data;
                }).catch(function () {}).finally(function () {
                  _this4.loading.municipio = false;
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getLocalidad: function getLocalidad(value) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading.localidad = true;

                _getLocalidad(value).then(function (res) {
                  _this5.levels.localidad = res.data;
                }).catch(function () {}).finally(function () {
                  _this5.loading.localidad = false;
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // eslint-disable-next-line no-unused-vars
    getDepartamento: function getDepartamento() {
      var _this6 = this;

      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.loading.departamento = true;
      getDepartamentos().then(function (res) {
        _this6.levels.departamento = res.data;
      }).catch(function () {}).finally(function () {
        _this6.loading.departamento = false;
      });
    }
  }
};